"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:no-console */
class FallbackLog {
    static log(msg) {
        console.error(`UniverseLog.FallbackLog: ${msg}`);
    }
}
exports.FallbackLog = FallbackLog;
//# sourceMappingURL=FallbackLog.js.map